module.exports = __webpack_public_path__ + "img/check.15de60a1.svg";